"use client"
import { useEffect } from 'react';
import styles from "./page.module.css";
import { useRouter } from 'next/navigation';
import LoadingIndicator from '@/components/LoadingIndicator';
import { useAuth } from '@/components/AuthProvider';

export default function Home() {
  const router = useRouter();
  const { account } = useAuth();
  useEffect(() => {
    if (account) {
      router.replace('/reports');
    }
  }, [router, account]);

  return (
    <div>
      <main className={styles.main}>
         <LoadingIndicator text='Loading Reports...' />
      </main>
    </div>
  );
}

